/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_Ready_Preview_HeadingInputs */



/**
* | output |
* | --- |
* | "This week" |
*
* @param {Onboarding_Pilot_Ready_Preview_HeadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_preview_heading = /** @type {((inputs?: Onboarding_Pilot_Ready_Preview_HeadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_Preview_HeadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze week")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette semaine")
	return /** @type {LocalizedString} */ ("This week")
});